<template>
  <v-flex d-flex>
    <v-container fluid>
      <v-card color="white">
        <v-card-title primary-title>
          <h3 class="headline mb-0">Currencies</h3>
        </v-card-title>
        <v-card-actions>
            <v-radio-group v-model="currencySelected" row class="ma-2">
              <v-flex v-for="currency in currencies" :key="currency.name" >
                <v-radio class="mr-4"
                  :value="currency.name"
                  :color="currency.color"
                  @click.native="currencySelect(currency.name)" 
                >
                  <div slot="label">
                    <v-icon :color="currency.color">{{currency.icon}}</v-icon>
                    <strong v-bind:class="currency.textColor"> {{currency.name}}</strong>
                  </div>
                </v-radio>
              </v-flex>
            </v-radio-group>
        </v-card-actions>
      </v-card>
      <v-card v-if="currencySelected">
        <v-tabs v-model="tabActive" >
          <v-tab ripple >
            Main & Sub
          </v-tab>
          <v-tab-item >
            <BitstampFundTransfer :accounts="accounts" />
          </v-tab-item>
          <!-- <v-tab ripple >
            Withdraw
          </v-tab>
          <v-tab-item >
            <FundTransfer />
          </v-tab-item> -->
        </v-tabs>
      </v-card>
    </v-container>
  </v-flex>
</template>

<script>
import BitstampFundTransfer from './BitstampFundTransfer'
import FundTransfer from './FundTransfer'
import MongoService from '../../services/mongo.service'
export default {
  data() {
    return {
      currencies: [
        {name: 'XRP', icon: 'cf-xrp', color: 'light-blue darken-1', textColor: 'light-blue--text text--darken-1' },
        {name: 'MESG', icon: '', color: 'purple darken-2', textColor: 'purple--text text--darken-3' }
      ],
      currencySelected: null,
      tabActive: null,
      accounts: null
    };
  },
  components: {
    BitstampFundTransfer,
    FundTransfer
  },
  methods: {
    async currencySelect (currentCurrency) {
      this.accounts = null
      try {
        const accounts = await MongoService.fund.balancesBitstampSubAccount({token: currentCurrency})
        this.accounts = accounts.map(account => {
          console.log(account.account_name)
          account.btc = account.balances.length > 0 ? account.balances.find(b => b.currency.toUpperCase() === 'BTC').balance : 0
          account.usd = account.balances.length > 0 ? account.balances.find(b => b.currency.toUpperCase() === 'USD').balance : 0
          switch (account.account_name.toLowerCase()) {
            case 'main':
              account.sorter =  0;
              break
            case 'sunday':
              account.sorter  = 1;
              break
            case 'monday':
              account.sorter  = 2;
              break
            case 'tuesday':
              account.sorter  = 3;
              break
            case 'wednesday':
              account.sorter  = 4;
              break
            case 'thursday':
              account.sorter  = 5;
              break
            case 'friday':
              account.sorter  = 6;
              break
            case 'saturday':
              account.sorter  = 7;
            default:
              account.sorter = 8;
          }
          account.balances.sort(
            (a, b) => {
            return b.balance - a.balance
          })
          return account
        });
      } catch (error) {
        console.error(error)
      }
    },
  }
};
</script>
